import type { QueryClient, Updater } from '@tanstack/react-query';
import type { QueryKeyData } from './query-options';

export const setQueriesDataFromKey = <TEntry extends QueryKeyData<unknown>>(
  queryClient: QueryClient,
  queryKey: TEntry['key'],
  updater: Updater<TEntry['data'] | undefined, TEntry['data'] | undefined>,
) => {
  queryClient.setQueriesData<TEntry['data']>({ queryKey }, updater);
};
